import { create } from 'zustand';
import { supabase } from '@/lib/supabase/client';
import { BOMState } from './types';
import { createBOMBaseSlice } from './bomBaseOperations';
import { createBOMComponentSlice } from './bomComponentOperations';
import { logger } from './logger';

/**
 * Creates a combined BOM store with all operations integrated
 */
export const createBOMStore = () => {
  logger.info('Creating BOM store');
  
  // Use create from zustand to create a store with all the slices
  return create<BOMState>((set, get) => ({
    ...createBOMBaseSlice(set, get),
    ...createBOMComponentSlice(set, get)
  }));
};

// Create and export a singleton instance of the BOM store
export const useBomStore = createBOMStore();

// Export types and utils for easy reuse
export * from './types';
export * from './utils';
